import { render, staticRenderFns } from "./AnswerHistoryReview.vue?vue&type=template&id=942c4c2c&"
import script from "./AnswerHistoryReview.vue?vue&type=script&lang=js&"
export * from "./AnswerHistoryReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports